













































import {Component, Vue} from 'vue-property-decorator';
import walktrough from '@/components/RegisterForm/FormWalktrough.vue';
import formRegister from '@/components/RegisterForm/FormRegister.vue';

@Component({
  components: {walktrough, formRegister},
})
export default class Login extends Vue {
  showForm = true;

  get appName() {
    return process.env.VUE_APP_NAME;
  }
  showFormRegis(val: boolean) {
    this.showForm = val;
  }
}
